import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import styles from './GoogleSheetsConfig.module.css';

const GoogleSheetsConfig = forwardRef(({ googleSheetsConfig, onValidate }, ref) => {
    console.log('Google Sheets Config:', googleSheetsConfig);
    const [localConfig, setLocalConfig] = useState({
        spreadsheetId: googleSheetsConfig?.spreadsheetId || '',
        sheetName: googleSheetsConfig?.sheetName || '',
        isShared: googleSheetsConfig?.isShared || false,
        appendData: googleSheetsConfig?.appendData || false
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (googleSheetsConfig) {
            
            setLocalConfig({
                spreadsheetId: googleSheetsConfig.spreadsheetId || '',
                sheetName: googleSheetsConfig.sheetName || '',
                isShared: googleSheetsConfig.isShared || false,
                appendData: googleSheetsConfig.appendData || false
            });
        }
    }, [googleSheetsConfig]);

    const validateFields = () => {
        const newErrors = {};
        if (!localConfig.spreadsheetId.trim()) {
            newErrors.spreadsheetId = 'Spreadsheet ID is required.';
        }
        if (!localConfig.sheetName.trim()) {
            newErrors.sheetName = 'Sheet Name is required.';
        }
        if (!localConfig.isShared) {
            newErrors.isShared = 'You must confirm the spreadsheet is shared.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useImperativeHandle(ref, () => ({
        handleValidation: () => {
            if (validateFields()) {
                onValidate({ ...localConfig });
                return true;
            }
            return false;
        },
        getConfig: () => ({ ...localConfig })
    }));

    return (
        <div>
            <div className={styles['form-group']}>
                <label className={styles['form-label']}>Spreadsheet ID</label>
                <input 
                    type="text" 
                    className={styles['form-input']}
                    value={localConfig.spreadsheetId}
                    onChange={(e) => setLocalConfig({
                        ...localConfig,
                        spreadsheetId: e.target.value
                    })}
                    placeholder="Enter the Spreadsheet ID from the URL"
                />
                {errors.spreadsheetId && <p className={styles['error-message']} style={{ color: 'red', fontSize: '0.9em', marginTop: '5px' }}>{errors.spreadsheetId}</p>}
            </div>
            <div className={styles['form-group']}>
                <label className={styles['form-label']}>Sheet Name</label>
                <input 
                    type="text" 
                    className={styles['form-input']}
                    value={localConfig.sheetName}
                    onChange={(e) => setLocalConfig({
                        ...localConfig,
                        sheetName: e.target.value
                    })}
                    placeholder="Enter the name of the sheet (e.g. Sheet1)"
                />
                {errors.sheetName && <p className={styles['error-message']} style={{ color: 'red', fontSize: '0.9em', marginTop: '5px' }}>{errors.sheetName}</p>}
            </div>
            <div className={styles['instructions-box']}>
                <h4 className={styles['instructions-title']}>How to share your spreadsheet:</h4>
                <ol className={styles['instructions-list']}>
                    <li>Open your Google Spreadsheet.</li>
                    <li>Click the "Share" button in the top-right corner.</li>
                    <li>Add <span className={styles['instructions-emphasis']}>ledgerview@ledgerview.iam.gserviceaccount.com</span> as an Editor.</li>
                    <li>Save the sharing settings.</li>
                </ol>
            </div>
            <div className={styles['checkbox-container']}>
                <input
                    type="checkbox"
                    id="is-shared"
                    className={styles['checkbox-input']}
                    checked={localConfig.isShared}
                    onChange={(e) => setLocalConfig({
                        ...localConfig,
                        isShared: e.target.checked
                    })}
                />
                <label htmlFor="is-shared" className={styles['checkbox-label']}>
                    I have shared the spreadsheet with the QuickBooks service account
                </label>
                {errors.isShared && <p className={styles['error-message']} style={{ color: 'red', fontSize: '0.9em', marginTop: '5px' }}>{errors.isShared}</p>}
            </div>
            {/* <div className={styles['checkbox-container']}>
                <input
                    type="checkbox"
                    id="append-data"
                    className={styles['checkbox-input']}
                    checked={localConfig.appendData}
                    onChange={(e) => setLocalConfig({
                        ...localConfig,
                        appendData: e.target.checked
                    })}
                />
                <label htmlFor="append-data" className={styles['checkbox-label']}>
                    Append data to the sheet
                </label>
            </div> */}
        </div>
    );
});

export default GoogleSheetsConfig;